import { render, staticRenderFns } from "./SignatureField.vue?vue&type=template&id=81fd6c86&scoped=true"
import script from "./SignatureField.vue?vue&type=script&lang=js"
export * from "./SignatureField.vue?vue&type=script&lang=js"
import style0 from "./SignatureField.vue?vue&type=style&index=0&id=81fd6c86&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "81fd6c86",
  null
  
)

export default component.exports